import { api } from "../../services/api";

export async function fetchSaldo() {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem("@medusapayments:access_token");
    api
      .get("/balance", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
}
